import React from "react";

const steps = [
  {
    n: "01",
    title: "Análise do perfil",
    desc: "Entendemos sua necessidade, prazo e estratégia financeira para indicar a melhor operação.",
  },
  {
    n: "02",
    title: "Seleção da carta contemplada",
    desc: "Apresentamos cartas com valor, prazo e condições alinhados ao seu projeto.",
  },
  {
    n: "03",
    title: "Validação documental",
    desc: "Revisão jurídica e operacional completa, com transparência em cada etapa.",
  },
  {
    n: "04",
    title: "Formalização segura",
    desc: "Transferência formalizada junto à administradora, com respaldo contratual.",
  },
  {
    n: "05",
    title: "Liberação da operação",
    desc: "Acesso ao capital de forma estruturada para aplicação imediata.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="como-funciona"
      data-testid="howitworks-section"
      className="relative bg-[#05070D] py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-20">
          <div className="flex items-center gap-4 mb-6">
            <div className="gold-line" />
            <span className="overline">Como Funciona</span>
          </div>
          <h2 className="font-serif-ag text-white text-4xl md:text-5xl lg:text-[3.5rem] font-light leading-[1.05] tracking-[-0.015em]">
            Um processo{" "}
            <span className="text-[#D4AF37] italic">claro, seguro</span> e
            consultivo.
          </h2>
        </div>

        <ol className="relative border-l border-[#D4AF37]/20 ml-2 md:ml-6 space-y-14">
          {steps.map((s, i) => (
            <li
              key={i}
              data-testid={`step-${i}`}
              className="pl-8 md:pl-14 relative group"
            >
              <span className="absolute -left-[7px] top-2 w-3 h-3 rounded-full bg-[#D4AF37] ring-4 ring-[#05070D]" />
              <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-start">
                <div className="md:col-span-2">
                  <span className="font-serif-ag text-5xl md:text-6xl text-[#D4AF37]/30 group-hover:text-[#D4AF37] transition-colors duration-500 font-light">
                    {s.n}
                  </span>
                </div>
                <div className="md:col-span-10">
                  <h3 className="font-serif-ag text-white text-2xl md:text-3xl font-light leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-[#A3ABB8] text-base md:text-lg font-light leading-relaxed max-w-2xl">
                    {s.desc}
                  </p>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
